<template>
  <div class="step">
    <h2>포장 옵션</h2>
    <div class="canvasPacking canvasOption">
      <div>
        <p>OPP개별포장</p>
        <span>(OPP봉투에 개별포장되어 발송)</span>
        <hr />
        <img src="@/assets/goods/packing_개별_active.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.step {
  width: 380px;
  margin: 0 auto 55px;

  > h2 {
    margin-bottom: 13px;
  }

  > .canvasOption {
    width: 380px;
    height: 230px;
    border: 2px solid #ff6699;
    background-color: #fff7fa87;
    border-radius: 10px;

    > div {
      width: 348px;
      margin: 18px auto 0;
      text-align: center;

      > p {
        font-size: 16px;
        color: #707070;
        text-align: left;
      }

      > span {
        display: block;
        font-size: 10px;
        color: #707070;
        margin-bottom: 5px;
        text-align: left;
      }

      > hr {
        width: 100%;
        height: 1px;
        background-color: #e6e6e6;
        border: none;
      }

      > img {
        width: 97px;
        height: 128px;
        margin-top: 14px;
      }
    }
  }
}
</style>
